import React, { Component } from 'react';
import Header from '../.././Header';
import Image from '../.././Image';
import classnames from 'classnames';

export default class Rainmakers extends Component {
  // static propTypes = {}
  // static defaultProps = {}
  // state = {}

  render() {
    const { className } = this.props;

    const navLinks = [
      {path: "/projects", title: "Projects"}
    ]

    const slug = "rainmakers";
    const screenshots = [
      {id: 'rainmakers-1', title: 'Rainmakers', content: 'Adopted a timeless and neutral serif font for the Rainmakers brand. Capitalized the letters and spaced them out for a more classy look. Font used: Trajan Pro.'},
      {id: 'rainmakers-2', title: 'Will 2011 Be the Year of the iPad 2?', content: 'The marketing banner for our first miniconference focused on mobile. Used the app icon layout to highlight the speakers and their companies\' respective mobile apps. Font used: Avenir.'},
      {id: 'rainmakers-3', title: 'Bridging People and Technology with Design', content: 'The marketing banner for our second miniconference focused on design. The direction for the banner was a collage of artsy elements, such as colored pencils and sketch paper. Font used for the title: Marketing Script.'},
      {id: 'rainmakers-4', title: 'To Product/Market Fit and Beyond', content: 'The marketing banner for our third miniconference on seed funding. Presented a hockey stick graph depicting the growth of a startup and its point of product/market fit. Inspired by a Dwolla graph.'},
    ];

    return (
      <div className={classnames('Rainmakers', className)}>
        <Header links={navLinks} />
        <div className="container">
          <div className="section">
            <div className="section-content">
              <div className="section-header">Rainmakers</div>
              <div className="section-title">Description</div>
              <div className="section-copy">
                <ul>
                  <li><strong>Objective</strong>: Organize startup panels for students and entpreneurs</li>
                  <li><strong>Role</strong>: Co-organizer and designer</li>
                  <li><strong>Team</strong>: Amanda Lim, Julian Koo</li>
                  <li><strong>Duration</strong>: Jan 2011—Nov 2011 (11 months)</li>
                </ul>
              </div>
              <div className="section-title">Highlights</div>
              <div className="section-copy">
                <ul>
                  <li>Organized 3 startup panels over the course of a year, ticketing over 800 attendees in total</li>
                  <li>Raised $7K sponsorship from key partners including SingTel Idea Factory, Infocomm Investments, Infocomm Development Authority of Singapore, UserVoice and WebFWD Mozilla</li>
                  <li>Secured partnerships with organizations including Yelp, Girls in Tech, SVNewTech, as well as Stanford's ASES and BASES</li>
                  <li>Televised the 3rd miniconference to Singapore live, with audience participation from both the Silicon Valley and Singapore attendees</li>
                </ul>
              </div>
              <div className="section-title">Summary</div>
              <div className="section-copy">
                <p>
                  Rainmakers is a series of startup panels held in Stanford University and AOL, Palo Alto around the themes of mobile applications, user experience design and early stage funding. I co-organized Rainmakers with Amanda Lim and Julian Koo, and our goal was to bring students, entrepreneurs and industry professionals closer together.
                </p>
                <p>
                  Our first miniconference was open to just students initially, but Rainmakers slowly gained traction among startup folks and working professionals as well. We sought out other meetup groups and blogs in order to reach a wider audience, and also reached out to venture capital firms and startups for sponsorship.
                </p>
                <p>
                  For our last event, we telecasted it to Singapore live at National University of Singapore, and had the audience participate through Pigeonhole Live. Over all our events, we ticketed around 800 attendees in total.
                </p>
              </div>
              <div className="section-title">Designs</div>
              <div className="section-images">
                {
                  Object.keys(screenshots).map(function(key) {
                    return (
                      <Image slug={slug} id={screenshots[key]['id']} title={screenshots[key]['title']} content={screenshots[key]['content']} />
                    )
                  })
                }
              </div>
              <div className="section-title">Press</div>
              <div className="section-copy">
                <ul>
                  <li><a href="https://www.techinasia.com/you-dont-need-professional-designers-to-develop-good-products/">You don&#039;t need professional designers to develop good products</a></li>
                  <li><a href="http://tusb.stanford.edu/2011/06/bridging-people-and-technology-with-design.html">Bridging People and Technology with Design</a></li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Projects/Rainmakers/index.js